<template>
  <SidebarLayout :full-height="true">
    <AppConfirmDialog />
    <slot />
  </SidebarLayout>
</template>
